<template>
  <div class="panel mt-20">
    <router-link
      v-permission="Auth.orderNew"
      :to="'/dashboard/order_editor?customer=' + customerID"
    >
      <el-button type="primary" icon="el-icon-s-order" size="small"
        >新报价</el-button
      >
    </router-link>
    <el-table v-if="!isMobile()" :data="orders" stripe key="orders">
      <el-table-column prop="number" label="报价单号" width="200">
        <template slot-scope="scope">
          <order-link :order="scope.row"></order-link>
          <!-- <br />
          <router-link
            class="text-info-12"
            :to="{
              path: '/dashboard/quotations/' + scope.row.quotation.id,
            }"
            >{{ scope.row.quotation.number }}</router-link
          > -->
        </template>
      </el-table-column>
      <el-table-column prop="order_info.project_name" label="项目">
      </el-table-column>
      <el-table-column prop="created_at" label="日期" width="180px">
        <template slot-scope="scope">
          <span>
            {{ formatTime(scope.row.created_at, 'YYYY-M-D HH:mm') }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="金额(￥)" width="160px">
        <template slot-scope="scope">
          <span>{{ scope.row.order_info.amount }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="剩余回款(￥)" width="120px">
        <template slot-scope="scope">
          <span></span>
        </template>
      </el-table-column> -->
      <el-table-column label="状态" width="160px">
        <template slot-scope="scope">
          <span
            class="status-point"
            :class="'bg-' + CustomerOrderStatusMap[scope.row.status].type"
          ></span>
          <span
            :class="'text-' + CustomerOrderStatusMap[scope.row.status].type"
          >
            {{ CustomerOrderStatusMap[scope.row.status].name }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <ul v-else class="list-style">
      <li v-for="item in orders" :key="item.id">
        <div class="flex-row-between">
          <order-link :order="item"></order-link>
          <span>￥{{ item.order_info.amount }}</span>
        </div>
        <div class="font-12 flex-row-between">
          <span>销售：{{ item.user.name }}</span>
        </div>
        <div class="font-12 flex-row-between">
          <span>{{ formatTime(item.created_at) }}</span>
          <span>
            <status-tag
              :type="CustomerOrderStatusMap[item.status].type"
              :name="CustomerOrderStatusMap[item.status].name"
            ></status-tag>
          </span>
        </div>
      </li>
    </ul>
    <div v-if="orders.length == 0 && isMobile()" class="text-info-12">
      暂未创建订单。
    </div>
  </div>
</template>

<script>
import { CustomerOrderStatusMap } from '@/config/global'
import { formatTime, isMobile } from '@/util/index'
import { customerOrderList } from '../../service/getData'
export default {
  props: {
    customerID: {
      type: Number,
    },
  },
  data() {
    return { formatTime, isMobile, CustomerOrderStatusMap, orders: [] }
  },
  created() {
    this.requestCustomerOrders()
  },
  methods: {
    async requestCustomerOrders() {
      let res = await customerOrderList({
        page: 0,
        size: 1000,
        customer_id: this.customerID,
      })

      if (res.code == 0) {
        this.orders = res.data.list
      }
    },
  },
}
</script>